var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunderette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{fill-rule:evenodd;}.b{fill:#e6007e;}.c{stroke:#e6007e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14,.01,2,0A1.993,1.993,0,0,0,0,2V19H2v2H14V19h2V2A1.985,1.985,0,0,0,14,.01ZM2,1H14a1,1,0,0,1,1,1V18H1V2A1,1,0,0,1,2,1ZM1,3H15V4H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8,16a5,5,0,1,1,5-5A5,5,0,0,1,8,16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunderette);
export default __webpack_public_path__ + "static/media/launderette.3b4383b7b8c51fbe97f4307a52f65db8.svg";
export { ForwardRef as ReactComponent };